import "core-js/modules/es.number.constructor.js";
import UserTaskDetail from "./UserTaskDetail";
// import JavaTaskDetail from "./JavaTaskDetail"
import ScriptTaskDetail from "./ScriptTaskDetail";
import ReceiveTaskDetail from "./ReceiveTaskDetail";
import MailTaskDetail from "./MailTaskDetail";
import TimerEventDetail from "./TimerEventDetail";
// import SignalEventDetail from "./SignalEventDetail"
// import MessageEventDetail from "./MessageEventDetail"
import GatewayDetail from "./GatewayDetail";
import FlowDetail from "./FlowDetail";
import StartEventDetail from "./StartEventDetail";
import EndEventDetail from "./EndEventDetail";
import ProcessDetail from "./ProcessDetail";
export default {
  inject: ['i18n'],
  components: {
    UserTaskDetail: UserTaskDetail,
    ScriptTaskDetail: ScriptTaskDetail,
    // JavaTaskDetail,
    ReceiveTaskDetail: ReceiveTaskDetail,
    MailTaskDetail: MailTaskDetail,
    TimerEventDetail: TimerEventDetail,
    // SignalEventDetail,
    // MessageEventDetail,
    GatewayDetail: GatewayDetail,
    FlowDetail: FlowDetail,
    StartEventDetail: StartEventDetail,
    EndEventDetail: EndEventDetail,
    ProcessDetail: ProcessDetail
  },
  props: {
    height: {
      type: Number,
      default: 800
    },
    model: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    users: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    authorities: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    groups: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    categorys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    signalDefs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    messageDefs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onChange: {
      type: Function,
      default: function _default() {}
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  }
};